module.exports = __webpack_public_path__ + "img/serve-background-03.b0f36e1d.png";